const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql } from '@apollo/client';
export const LINE_ITEM_ASSOCIATION_SPEC = {
  associationCategory: 'HUBSPOT_DEFINED',
  associationTypeId: 1053
};
export const CONTACT_ASSOCIATION_SPEC = {
  associationCategory: 'HUBSPOT_DEFINED',
  associationTypeId: 1043
};
export const CONTRACT_PROPERTY_VALUE_FIELDS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"ContractPropertyValueFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValue\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"definition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"groupName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fieldType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"formField\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyDefinition\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutableDefinitionNotDeletable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculated\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptions\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsReferenceType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"referencedObjectType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"showCurrencySymbol\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyPropertyName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubspotDefined\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"deleted\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"textDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"numberDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"options\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"doubleData\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnly\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ContractPropertyValueFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PropertyValue"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "value"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "definition"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "description"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "groupName"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "type"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "fieldType"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "formField"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "displayOrder"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "readOnlyValue"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "readOnlyDefinition"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hidden"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mutableDefinitionNotDeletable"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "calculated"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "externalOptions"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "externalOptionsReferenceType"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "displayMode"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "referencedObjectType"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "showCurrencySymbol"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "currencyPropertyName"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hubspotDefined"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "deleted"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "textDisplayHint"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "numberDisplayHint"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "options"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "label"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "displayOrder"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "doubleData"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hidden"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "readOnly"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "description"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const PROPERTY_VALUE_FIELDS_FRAGMENT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValueFieldsFragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValue\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PropertyValueFieldsFragment"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PropertyValue"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "value"
        }
      }]
    }
  }]
});
export const LINE_ITEM_PROPERTY_FIELDS_FRAGMENT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"LineItemPropertyFieldsFragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"LineItem\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyValueFieldsFragment\"}}]}}]}}]}", {
  kind: "Document",
  definitions: _unique([{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "LineItemPropertyFieldsFragment"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "LineItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "allProperties"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "PropertyValueFieldsFragment"
            }
          }]
        }
      }]
    }
  }].concat(PROPERTY_VALUE_FIELDS_FRAGMENT.definitions))
});